<template lang="pug">
  v-container
    v-layout(justify-end)
      a.ml-2(:href='href["cvs"]' :download='download["cvs"]' target='_blank')
        v-icon fa-file-csv
      a.ml-2(:href='href["excel"]' :download='download["excel"]' target='_blank')
        v-icon far fa-file-excel
</template>
<script>
import {getStringToday} from '@/Helper'
export default {
  data: ()=>({
    href: {
      'excel': '',
      'cvs': ''
    },
    download:  {
      'excel': '',
      'cvs': ''
    },
  }),
  props: {
    dataToPrint: Array
  },
  watch:{
    'dataToPrint'(){
      this.toDownload('excel')
      this.toDownload('cvs')
    }
  },
  methods: {
    toDownload(type){
      if(this.dataToPrint.length==0) return 

      let textToPrint = ""
      textToPrint += (type=='excel') ? '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta charset="UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table><tr>' : ''
      if (type=='excel') {
        Object.keys(this.dataToPrint[0]).map(key=> (key!='key') ? textToPrint += '<td>' + key +'</td>' : '')
      } else {
        Object.keys(this.dataToPrint[0]).map(key=> (key!='key') ? textToPrint += key + ',' : '')
      }
        

      textToPrint +=(type=='excel')? "</tr>" : "\r\n"
        this.dataToPrint.map( RowItem => {
          textToPrint +=(type=='excel')?"<tr>":'';
          (type=='excel')
            ? Object.keys(RowItem).map(key=> (key!='key') ? textToPrint += '<td>'+RowItem[key] +'</td>' : null)
            : Object.keys(RowItem).map(key=>(key!='key') ? textToPrint += RowItem[key] + ',' : null)
          textToPrint +=(type=='excel')?"</tr>":"\r\n"
           
        })
        if (type=='excel') textToPrint +='</table></body></html>'
        this.makeFile(textToPrint, type)
        
      
    },
    makeFile(content, type){
        let blob = new Blob([content], {type: (type=='cvs')?'application/cvs;charset=UTF-8;base64,':'application/vnd.ms-excel;charset=UTF-8;base64'})
        let url = window.URL.createObjectURL(blob)
        this.href[type] = url
        this.download[type] =(type=='excel')? getStringToday() + '.xls':getStringToday()+'.cvs'
    }
  }
}
</script>
